
<div class="popup-wrapper" *ngIf="(!isStorypage || !data?.config?.theme || miniStory)">
  <div class="close-btn">
    <i class="material-icons" (click)="handleCloseAndSendEvent('closeBtn')">close</i>
  </div>
 <div class="top-img-wrapper">
   <img [src]="'/assets/images/donation-confirmation-img.png'" />
 </div>
 <div class="content">
   <div class="title">
     {{info.title}}
   </div>
   <div class="description" [innerHTML]="info.description(beneficiaryName, data?.contributeDetails?.min_donation, utilService.getCurrencyIcon(data?.currency).symbol)">
   </div>
 </div>
 <div class="action-wrapper">
   <app-button label="Yes, I will help" btnClass="full-width" (click)="handleCloseAndSendEvent('help')"></app-button>
   <button mat-button  class="full-width" (click)="handleCloseAndSendEvent('cancel')">
     Sorry, not today
   </button>
 </div>
</div>

<div class="popup-wrapper" *ngIf="data?.config?.theme === 'v1' && isStorypage && !miniStory" [ngClass]="data?.config?.theme">
  <div class="close-btn">
    <i class="material-icons" (click)="handleCloseAndSendEvent('cancel')">close</i>
  </div>
 <div class="top-img-wrapper">
   <img [src]="'/assets/images/exit-intent-img.png'" />
 </div>
 <div class="content">
   <div class="title">
     {{info.title1}}
   </div>
   <div class="description">
     <!-- {{info.description1(beneficiaryName)}} -->
   </div>
 </div>
 <div class="action-wrapper">
</div>
</div>